import { render, staticRenderFns } from "./need-download-app.vue?vue&type=template&id=8f310e9e&scoped=true"
import script from "./need-download-app.vue?vue&type=script&lang=js"
export * from "./need-download-app.vue?vue&type=script&lang=js"
import style0 from "./need-download-app.vue?vue&type=style&index=0&id=8f310e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f310e9e",
  null
  
)

export default component.exports